import type {DiffLineType} from '@github-ui/diffs/types'
import type {SafeHTMLString} from '@github-ui/safe-html'
import {VerifiedHTMLDiv} from '@github-ui/safe-html/VerifiedHTML'
import {clsx} from 'clsx'
import {memo} from 'react'

// the actual diff line text itself needs to be memoized because otherwise when the parent re-renders, any
// selections (either from click dragging selection or from control+f highlighting) will be lost
export const LineTextWrapper = memo(function LineTextWrapper({
  lineHtml,
  lineType,
  lineTypeCharacter,
}: {
  lineHtml: string
  lineType: DiffLineType
  lineTypeCharacter: string | undefined
}) {
  return (
    <code
      className={clsx('diff-text syntax-highlighted-line', {
        addition: lineType === 'ADDITION',
        deletion: lineType === 'DELETION',
      })}
    >
      {lineTypeCharacter && <span className="diff-text-marker">{lineTypeCharacter}</span>}
      <VerifiedHTMLDiv html={lineHtml as SafeHTMLString} className="diff-text-inner" />
    </code>
  )
})

try{ LineTextWrapper.displayName ||= 'LineTextWrapper' } catch {}